import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api/client";

const CurrencyContext = createContext();

const LS_KEY = "777_currency";

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try {
      return localStorage.getItem(LS_KEY) || "RSD";
    } catch {
      return "RSD";
    }
  });
  const [rate, setRate] = useState(null);

  useEffect(() => {
    api
      .get("/api/currency/rate")
      .then((res) => setRate(res.data.data))
      .catch(() => setRate({ RSD: 1, EUR: 0.00855, USD: 0.00935 }));
  }, []);

  const setCurrency = useCallback((c) => {
    setCurrencyState(c);
    try {
      localStorage.setItem(LS_KEY, c);
    } catch {
      /* ignore */
    }
  }, []);

  const formatPrice = useCallback(
    (amountRSD) => {
      if (!amountRSD && amountRSD !== 0) {
        if (currency === "EUR") return "€0.00";
        if (currency === "USD") return "$0.00";
        return "0 RSD";
      }

      if (currency === "EUR" && rate) {
        const eur = amountRSD * rate.EUR;
        return `€${new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(eur)}`;
      }

      if (currency === "USD" && rate) {
        const usd = amountRSD * rate.USD;
        return `$${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(usd)}`;
      }

      return `${new Intl.NumberFormat("sr-Latn-RS", { minimumFractionDigits: 0 }).format(amountRSD)} RSD`;
    },
    [currency, rate],
  );

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatPrice, rate }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
